import { Group } from "@dinahmoe/dmafjs-visual";

class Footer extends Group {
  namespace = "se26:footer";

  handlers = {
    "size.width": this.handleWidthChange,
  };

  handleWidthChange(node) {
    const linksContainer = node._ids?.links_container;
    const logosContainer = node._ids?.logos_container;
    if (!linksContainer) return;

    const isPortrait = node["size.width"] < 800;
    linksContainer["layout.direction"] = isPortrait ? "column" : "row";
    linksContainer["layout.gap"] = isPortrait ? 12 : 60;

    const isNarrow = node["size.width"] < 600;

    if (logosContainer) {
      logosContainer["layout.direction"] = isNarrow ? "column" : "row";
      logosContainer["layout.alignItems"] = isNarrow ? "flex-end" : "center";
      logosContainer["layout.gap"] = isNarrow ? 24 : 48;
    }

    node["padding.left"] = isNarrow ? 32 : 64;
    node["padding.right"] = isNarrow ? 32 : 64;
    node["padding.top"] = isNarrow ? 32 : 40;
    node["padding.bottom"] = isNarrow ? 32 : 64;
  }
}

const footer = new Footer();
export { footer, Footer };
